<template>
  <div class="custom-select-container">
    <div class="custom-select"
         :tabindex="tabindex">
      <div class="selected"
           :class="{open: open}"
           @click="open = !open">
        <img v-if="flags && selected.value" :src="'/img/lang/' + selected.value + '.png'"> {{ selected.label }}
      </div>
      <div class="items" :class="{selectHide: !open}">
        <div v-if="search" class="custom-select-search">
          <input type="search" v-model="searchOption" autocomplete="off">
        </div>
        <div class="item"
             v-for="(option, i) of optionsFiltred"
             :key="i"
             @click="selected = option; open = false; $emit('input', option.value)">
          <img v-if="flags && option.value" :src="'/img/lang/' + option.value + '.png'"> {{ option.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      options: {
        type: Array,
        required: true
      },
      tabindex: {
        type: Number,
        required: false,
        default: 0
      },
      flags: {
        type: Boolean,
        required: false,
        default: false
      },
      search: {
        type: Boolean,
        required: false,
        default: false
      },
      value: {
        type: String,
        required: false,
        default: false
      }
    },
    data() {
      return {
        selected: this.options.length > 0 ? this.options[0] : null,
        searchOption: '',
        open: false
      }
    },
    computed: {
      optionsFiltred() {
        let self = this
        let result = []

        for (let index in self.options) {
          if (self.options[index].label.toUpperCase().indexOf(self.searchOption.toUpperCase()) + 1) {
            result.push(self.options[index])
          }
        }
        return result
      }
    },
    mounted() {
      if (this.value)
        for (let index in this.options)
          if (this.options[index].value == this.value)
            this.selected = this.options[index]

      this.$emit('input', this.selected.value)
    }
  }
</script>

<style scoped lang="scss">
  .custom-select-container {
    box-sizing: border-box;
    display: inline-block;
    margin: 0;
    position: relative;
    vertical-align: middle;
    width: 100% !important;

    .custom-select {
      border: none !important;
      background: #fff;
      cursor: pointer;
      -webkit-box-shadow: 0 0 15px #DEDEDE;
      box-shadow: 0 0 15px #DEDEDE;
      -webkit-border-radius: 2px;
      border-radius: 2px;
      height: 48px;

      .selected {
        font-family: 'Montserrat';
        font-weight: 400;
        font-size: 14px;
        color: #000;
        line-height: 36px;
        padding-left: 10px;
        padding-right: 40px;
        display: block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        &.open {
          border-radius: 6px 6px 0 0;
        }
        &:after {
          min-width: 10px;
          max-width: 10px;
          height: 10px;
          content: ' ';
          background-image: url(/img/select-arrow.svg);
          background-repeat: no-repeat;
          background-position: top center;
          -webkit-background-size: contain;
          background-size: contain;
          border: none !important;
          -webkit-transform: translate(-50%, -50%);
          -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          margin-left: 0;
          margin-top: 0;
          z-index: 2;
          position: absolute;
          right: 15px;
          top: 25px;
        }
      }

      .items {
        border: none !important;
        background-color: #fff;
        -webkit-box-shadow: 0 0 15px #DEDEDE;
        box-shadow: 0 0 15px #DEDEDE;
        -webkit-border-radius: 2px;
        position: absolute;
        z-index: 999;
        width: 100%;
        margin: 6px 0 0 -12px;
        .custom-select-search {
          display: block;
          padding: 4px;
          input {
            border: 1px solid #DEDEDE;
            padding: 4px;
            width: 100%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
          }
        }
        .item {
          cursor: pointer;
          padding: 6px;
          color: #333;
          &.active, &:hover {
            color: #fff;
            background-color: #333;
          }
        }
      }

      .selectHide {
        display: none;
      }

      img {
        min-width: 21px;
        max-width: 21px;
        height: 11px;
        margin-right: 9px;
      }
    }
  }
</style>